import PropTypes from "prop-types";
import React from "react";

export const Facebook = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path
        strokeWidth={0}
        d="M16,2a14,14,0,0,0-2.19,27.81V20.12H10.26V16.07h3.55V13c0-3.51,2.09-5.45,5.29-5.45a21,21,0,0,1,3.13.28v3.44H20.47a2,2,0,0,0-2.28,2.19v2.62h3.88l-.62,4.05H18.19v9.69A14,14,0,0,0,16,2Z"
      />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      style,
      viewBox: "0 0 32 32",
    };
  }
};

Facebook.displayName = "FacebookIcon";

Facebook.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /**
   * custom allows for component to implement styling for a specific characteristic. There is no obligation for a
   * component to implement the custom prop.
   */
  custom: PropTypes.object,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Facebook.defaultProps = {
  role: "img",
};
